import { styled } from '@mui/material/styles';
import { Box, TextField } from '@mui/material';

// Container for the search bar; adjusts border-radius based on whether suggestions are shown.
export const SearchContainer = styled(Box)(({ theme, expanded }) => ({
  position: 'relative',
  width: '100%',
  margin: 'auto',
  transition: 'border-radius 0.3s ease',

  [theme.breakpoints.between('md', 'lg')]: {
    width: '90%',
    padding: theme.spacing(2),
  },
}));

export const Title = styled('h1')(({ theme }) => ({
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 'bold',
  marginBottom: theme.spacing(2),
  textAlign: 'center',
  marginTop:0
}));

// StyledTextField now accepts a showDropdown prop to adjust its border-radius.
export const StyledTextField = styled(TextField)(({ theme, showDropdown }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: showDropdown ? '30px 30px 0 0' : '30px',
    transition: 'border-radius 0.3s ease',
    '&.Mui-focused fieldset': {
      borderColor: '#ddd',
      borderWidth:'1px'
    },
    '& fieldset': {
      borderColor: '#ddd', // default border color
    },
    '&:hover fieldset': {
      borderColor: '#ddd', // hover border color
    },
  },
  '& .MuiOutlinedInput-notchedOutline':{
     borderBottom: showDropdown && '0px',
  },
  
  borderBottom: showDropdown && '0px',
  boxSizing: 'border-box'
}));

// SuggestionsList is absolutely positioned below the input.
export const SuggestionsList = styled('ul')(({ theme }) => ({
  listStyleType: 'none',
  margin: 0,
  padding: 0,
  backgroundColor: '#fff',
  border: '1px solid #ddd',
  // borderTop: 'none',
  borderRadius: '0 0 30px 30px',
  position: 'relative',
  top: '100%',
  left: 0,
  width: '100%',
  zIndex: 10,
  boxSizing: 'border-box',
}));

// SuggestionItem styling remains unchanged.
export const SuggestionItem = styled('li')(({ theme }) => ({
  padding: theme.spacing(2),
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
  borderBottom: '1px solid #ddd', // Divider line
  '&:last-child': {
    borderBottom: 'none', // Remove divider from the last item
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const ResultsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '100%',
  margin: `${theme.spacing(4)} auto`,
  padding: theme.spacing(2),
  backgroundColor: '#f9f9f9',
  borderRadius: '30px',
  display: 'grid',
  gap: theme.spacing(2),
  boxSizing: 'border-box',
}));

